// location filter form
const form = document.getElementById('location-filter');

// main filter categories
const filters = ['category', 'audience', 'city'];

// update url with filter values 
function updateUrl() {

    const url = new URL(window.location.href);

    filters.forEach(filter => {
        const value = document.getElementById(filter).value;
        if (value) {
            url.searchParams.set(filter, value);
        } else {
            url.searchParams.delete(filter);
        }
    });

    window.history.pushState({}, '', url);

}

// ajax get locations
function ajaxGetLocations() {

    const params = {};

    filters.forEach(filter => {
        params[filter] = encodeURIComponent(document.getElementById(filter).value);
    });

    const queryString = new URLSearchParams(params).toString();
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function() {
        if (xhr.readyState === XMLHttpRequest.DONE) {
            if (xhr.status === 200) {
                document.getElementById('search-results').innerHTML = xhr.responseText;
                updateUrl();
            } else {
                console.error('Request failed with status:', xhr.status);
            }
        }
    };

    xhr.open('GET', ajax_url + '?action=location_filter_results&' + queryString, true);
    xhr.send();
}

// get filter values from url
function getUrlFilterValues() {
    const url = new URL(window.location.href);

    filters.forEach(filter => {
        const value = url.searchParams.get(filter);
        if (value) {
            document.getElementById(filter).value = value;
        }
    });

    if (url.search !== '') {
        ajaxGetLocations();
    }
}

// on page load
document.addEventListener('DOMContentLoaded', function() {

    if(form) {

        getUrlFilterValues();

        form.addEventListener('submit', function(event) {
            event.preventDefault();
            ajaxGetLocations();
        });
    }

});